import axios from "axios";
import { wdKit_Form_data, get_user_login } from '../../helper/helper-function';
import { Bricks_data } from "../components-data/component_custom";


const Bricks_file_create = async (call, all_files, html, css, js, old_folder, image_file, d_image) => {

    /**
     * Generates a unique key based on the current year and a random string.
     *
     * @returns {string} A unique identifier.
     * @since 1.0.0
     * @version 1.0.0
     */
    const KeyUniqueID = () => {
        let year = new Date().getFullYear().toString().slice(-2),
            uid = Math.random().toString(36).substr(2, 6);
        return uid + year;
    }

    var layout_data = '',
        upload_path = wdkitData.WDKIT_SERVER_PATH,
        php_variable_validation = "",
        repeater_variable = {},
        js_link = [],
        css_link = [],
        php_variable = "",
        responses = { 'api': '', 'ajax': '' },
        Loopvar = [],
        php_editor_code = all_files.Editor_code?.Editor_codes?.[0]?.php,
        script_id = KeyUniqueID(),
        unique_class = KeyUniqueID();

    /**
     * Generates a unique three-digit key based on the current year and a random string.
     *
     * @returns {string} A three-digit unique identifier.
     * @since 1.0.0
     * @version 1.0.0
     */
    const ThreeDigitUnique = () => {
        let year = new Date().getFullYear().toString().slice(-2),
            uid = Math.random().toString(36).substr(2, 2);
        return uid + year;
    }

    /**
     * Generates a unique random number between 0 and 999999.
     *
     * @returns {number} A unique random number.
     * @since 1.0.0
     * @version 1.0.0
     */
    const UniqueNumber = () => {
        return Math.floor(Math.random() * 1000000)
    }

    /**
    * Process CSS data based on specific conditions and generate modified CSS.
    * 
    * @returns {string} Modified CSS data.
    * @since 1.0.0
    * @version 1.0.0
    */
    const CssValidation = () => {
        let parent_class = all_files.WcardData.widgetdata.widget_id,
            css_data = JSON.parse(css);

            if ( ! css_data ) {
                return '';
            }

        if (all_files?.WcardData?.widgetdata?.css_parent_node == true) {
            css_data = css_data.replaceAll("{{parent-class}}", `.wkit-wb-Widget_${parent_class}`);

            let css_array = css_data.split('}'),
                final_css = '';

            css_array.map((css) => {
                let data = css.trim();

                if (data.search('{') > -1) {
                    if (data.search("@import") > -1) {
                        final_css += data + '}';
                    } else if ('.' === data.charAt(0)) {
                        data = data.replace('.', `.wkit-wb-Widget_${parent_class} .`);
                        let pattern = /,.*{/;

                        if ((data.search(/,\s*\./) > -1) && data.match(pattern)) {
                            data = data.replace(/,\s*\./g, `, .wkit-wb-Widget_${parent_class} .`);
                        }
                        final_css += data + '}';
                        // } else if (data.charAt(0) != '*' && data.charAt(0) != '/' && data.charAt(0) != ':' && !data.startsWith('body') && data.search("@media") <= -1) {
                    } else if (data.charAt(0).match("[a-zA-Z]+") && !data.startsWith('body')) {
                        data = data.replace(data.charAt(0), `.wkit-wb-Widget_${parent_class} ` + data.charAt(0))
                        final_css += data + '}';
                    } else if ('*' == data.charAt(0)) {
                        data = data.replace('*', `.wkit-wb-Widget_${parent_class} `);
                        final_css += data + '}';
                    } else if (data.startsWith('body')) {
                        data = data.replace('body', `.wkit-wb-Widget_${parent_class} `);
                        final_css += data + '}';
                    } else if (data.search("@media") > -1) {
                        data = data.replace("{", ` {  .wkit-wb-Widget_${parent_class}`)
                        final_css += data + '}';
                    } else {
                        final_css += data + '}';
                    }
                } else if (data.search('{') <= -1) {
                    final_css += '}';
                }

            })
            final_css = final_css.slice(0, -1)
            return final_css;
        } else {
            css_data = css_data.replaceAll("{{parent-class}}", `.wkit-wb-Widget_${parent_class}`);
            return css_data;
        }
    }

    /**
     * Process image data and generate updated widgetdata object.
     * 
     * @param {string} img_ext - The file extension of the image.
     * @returns {Object} An object containing the updated widgetdata.
     * @since 1.0.0
     * @version 1.0.0
     */
    const ProcessIamge = (img_ext) => {
        let img_path = `${upload_path}/bricks/${NameValidation('folder')}/${NameValidation('file')}.${img_ext}`,
            add_val = Object.assign({}, all_files.WcardData.widgetdata, { "w_image": img_path, "img_ext": img_ext });
        return { 'widgetdata': add_val };
    }

    /**
     * Process image-related data and update the widgetdata object.
     *
     * @returns {Object} An object containing the updated widgetdata.
     * @since 1.0.0
     * @version 1.0.0
     */
    const ImageLink = () => {
        if (all_files?.WcardData?.widgetdata?.image_id) {
            delete all_files?.WcardData?.widgetdata?.image_id;
        }

        if (image_file && image_file.type) {
            let ext = image_file.type;
            var img_ext = '';
            if (ext.search('jpeg') > -1) {
                img_ext = 'jpg';
            } else if (ext.search('jpg') > -1) {
                img_ext = 'jpg';
            } else if (ext.search('png') > -1) {
                img_ext = 'png';
            } else {
                let add_val = Object.assign({}, all_files.WcardData.widgetdata, { "w_image": "", "img_ext": img_ext });
                return { 'widgetdata': add_val };
            }
            if (img_ext) {
                return ProcessIamge(img_ext);
            }

        } else if (old_folder) {
            let old_image = all_files.WcardData.widgetdata.w_image,
                image_array = old_image.split('.'),
                img_ext = image_array[image_array.length - 1];

            if (img_ext) {
                return ProcessIamge(img_ext);

            } else {
                return all_files.WcardData;
            }

        } else if (d_image) {
            let old_image = d_image,
                image_array = old_image.split('.'),
                img_ext = image_array[image_array.length - 1];

            if (img_ext) {
                return ProcessIamge(img_ext);

            } else {
                return all_files.WcardData;
            }

        } else {
            return all_files.WcardData;
        }
    }

    /**
     * Convert a string containing HTML markup into an HTML document.
     *
     * @param {string} str - The string containing HTML markup.
     * @returns {Document} An HTML document parsed from the input string.
     * @since 1.0.0
     * @version 1.0.0
     */
    const StringToHTML = function (str) {
        return new DOMParser().parseFromString(str, 'text/html');
    };

    /**
     * Validate and process HTML content by converting it to a string.
     *
     * @param {string} html - The HTML content to be validated and processed.
     * @returns {string} A sanitized string representation of the HTML content.
     * @since 1.0.0
     * @version 1.0.0
     */
    const HtmlValidation = (html) => {
        let repeater_html = StringToHTML(JSON.parse(html)),
            widgetHtml = repeater_html.head.innerHTML + repeater_html.body.innerHTML;
        return widgetHtml.replaceAll("'", "\\'");
    }

    var widgetHtml = HtmlValidation(html)

    /**
     * Validate and process a name based on the specified type.
     *
     * @param {string} type - The type of validation to perform ('file', 'folder', or other).
     * @returns {string} The validated and processed name.
     * @since 1.0.0
     * @version 1.0.0
     */
    const NameValidation = (type) => {
        var name = all_files.WcardData.widgetdata.name.trim(),
            id = all_files.WcardData.widgetdata.widget_id;

        if ("file" == type) {
            return name.replaceAll(" ", "_") + "_" + id;
        } else if ("folder" == type) {
            return name.replaceAll(" ", "-") + "_" + id;
        } else {
            return name;
        }
    }

    /**
     * Extract HTML elements with a specific data attribute from a string,
     * based on the provided name.
     *
     * @param {string} name - The data attribute name to target.
     * @returns {string[]} An array containing the outerHTML of matching HTML elements.
     * @since 1.0.0
     * @version 1.0.0
     */
    const GetLoopHtml = (name) => {
        let html = [],
            repeater_html = StringToHTML(widgetHtml),
            r_html_array = repeater_html.querySelectorAll(`[data-${name}]`);

        if (r_html_array.length > 0) {

            widgetHtml = repeater_html.head.innerHTML + repeater_html.body.innerHTML

            Object.values(r_html_array).map((r_html) => {
                html.push(r_html.outerHTML);
            })

            return html;
        }
    }

    /**
     * Change the URL hash based on specific conditions.
     *
     * @param {string} call - The call parameter used to determine the conditions for changing the URL hash.
     * @returns {undefined} Returns undefined after changing the URL hash.
     * @since 1.0.0
     * @version 1.0.0
     */
    const ChangeUrl = () => {

        if ("update" === call || "sync" === call && old_folder != undefined) {
            let array = new URL(window.location).hash.split("/"),
                url_length = (array.length - 1),
                R_name = all_files.WcardData.widgetdata.name.trim() + "_" + all_files.WcardData.widgetdata.widget_id;

            array[url_length] = R_name;

            document.location.hash = array.join('/');
        }
    }
    ChangeUrl();

    /**
     * Check and process a loop with a specified name, updating HTML and generating PHP variables accordingly.
     *
     * @param {string} loop_name - The name of the loop to check.
     * @returns {boolean|undefined} Returns `false` if the loop conditions are not met, otherwise `undefined`.
     * @since 1.0.0
     * @version 1.0.0
     */
    const CheckLoop = async (loop_name) => {

        if (loop_name) {
            let loop_html = GetLoopHtml(loop_name);
            loop_html?.length > 0 && loop_html?.map((sl_html, index) => {

                if (sl_html) {

                    var html = StringToHTML(sl_html);
                    Loopvar.map((loop) => {
                        if (loop.name != loop_name) {
                            let findHTML = html.querySelectorAll(`[data-${loop.name}]`);
                            if (findHTML.length > 0) {
                                CheckLoop(loop.name)
                            }
                        }
                    })

                    let new_html = GetLoopHtml(loop_name);

                    if (new_html.length > 0) {

                        let loopDataIndex = Loopvar.findIndex((l_data) => l_data.name == loop_name),
                            loopData = Loopvar[loopDataIndex];

                        if ('repeater' == loopData.type) {
                            let uniqueID = ThreeDigitUnique(),
                                fields = `$${loopData.name + "_" + uniqueID} .= '${new_html[0]}';`;
                            php_variable += `$${loopData.name + "_" + uniqueID} = '';
                            if ( $this->settings['${loopData.name}'] ) {
                                foreach ( $this->settings['${loopData.name}'] as $key => $r_item ) {
                                    ${repeater_variable?.[loopData.name] ? repeater_variable?.[loopData.name] : ''}
                                    ${fields}
                                }
                            }`;

                            widgetHtml = widgetHtml.replace(new_html[0], `'.$${loopData.name + "_" + uniqueID}.'`);

                        } else if ('gallery' == loopData.type) {
                            let uniqueID = ThreeDigitUnique();
                            if (loopData?.repeater != undefined) {
                                var r_html = `$${loopData.name + "_" + uniqueID} = '';
                                if($r_item['${loopData.name}']){
                                    foreach ( ${loopData?.repeater ? '$r_item' : '$this->settings'}['${loopData.name}']['images'] as $image ) {
                                        $${loopData.name} =  wp_get_attachment_image(
                                            $image['id'],
                                            $r_item['${loopData.name}']['size'],
                                            false,
                                            ['class' => 'css-filter']
                                          );
                                        $${loopData.name + "_" + uniqueID} .= '${new_html[index]}';
                                    }
                                }`

                                if (repeater_variable?.[loopData?.repeater]) {
                                    r_html = repeater_variable?.[loopData?.repeater] + r_html;
                                }
                                repeater_variable = Object.assign({}, repeater_variable, { [loopData?.repeater]: r_html })
                            } else {
                                php_variable_validation += `$${loopData.name + "_" + uniqueID} = '';
                                if( !empty ($this->settings['${loopData.name}'])){
                                    foreach ( ${loopData?.repeater ? '$r_item' : '$this->settings'}['${loopData.name}']['images'] as $image ) {
                                        $${loopData.name} =  wp_get_attachment_image(
                                            $image['id'],
                                            $this->settings['${loopData.name}']['size'],
                                            false,
                                            ['class' => 'css-filter']
                                          );
                                        $${loopData.name + "_" + uniqueID} .= '${new_html[index]}';
                                    }
                                }`
                            }
                            widgetHtml = widgetHtml.replace([new_html[index]], `'.$${loopData.name + "_" + uniqueID}.'`);
                        } else if ('select2' == loopData.type) {
                            let uniqueID = ThreeDigitUnique();

                            if (loopData?.repeater) {
                                if (loopData?.multiple) {
                                    var r_html = `$${loopData.name + "_" + uniqueID} = '';
                                    if ( $r_item['${loopData.name}'] && $r_item['${loopData.name}'] != "undefined" ) {
                                        foreach ( $r_item['${loopData.name}'] as $s_item  ) {
                                            $${loopData.name + "_" + uniqueID} .= '${new_html[index]}';
                                        }
                                    }`
                                } else {
                                    var r_html = `$${loopData.name + "_" + uniqueID} = '';
                                    if ( $r_item['${loopData.name}'] && $r_item['${loopData.name}'] != "undefined" ) {
                                            $${loopData.name + "_" + uniqueID} .= '${new_html[index]}';
                                    }`
                                }

                                if (repeater_variable?.[loopData?.repeater]) {
                                    r_html = repeater_variable?.[loopData?.repeater] + r_html;
                                }

                                repeater_variable = Object.assign({}, repeater_variable, { [loopData?.repeater]: r_html })

                            } else {
                                if (loopData?.multiple) {
                                    php_variable_validation += `$${loopData.name + "_" + uniqueID} = '';
                                    if (  $this->settings['${loopData.name}'] ) {
                                        foreach (  $this->settings['${loopData.name}'] as $s_item  ) {
                                            $${loopData.name + "_" + uniqueID} .= '${new_html[index]}';
                                        }
                                    }`
                                } else {
                                    php_variable_validation += `$${loopData.name + "_" + uniqueID} = '';
                                    if (  $this->settings['${loopData.name}'] ) {
                                            $${loopData.name + "_" + uniqueID} .= '${new_html[index]}';
                                    }`
                                }
                            }

                            widgetHtml = widgetHtml.replace([new_html[index]], `'.$${loopData.name + "_" + uniqueID}.'`);
                        }

                    } else {
                        return false;
                    }
                }
            })
        }
    }

    /**
     * Controller function to handle HTML loop for a component with repeater.
     *
     * @param {object} compo - The component object.
     * @param {string} repeater - The repeater name.
     * @returns {string} The generated settings for the component.
     * @since 1.0.0
     * @version 1.0.0
     */
    const ControllerHtmlLoop = (compo, repeater) => {

        var settings = "";

        if (compo.type == 'url') {

            if (repeater) {
                let r_html = `$${compo.name}_is_external = isset($r_item['${compo.name}']) && isset($r_item['${compo.name}']['is_external']) ? $r_item['${compo.name}']['is_external'] : '';\n`
                r_html += `$${compo.name}_url = isset($r_item['${compo.name}']) && isset($r_item['${compo.name}']['url']) ? $r_item['${compo.name}']['url'] : '';\n`
                r_html += `$${compo.name}_nofollow = isset($r_item['${compo.name}']) && isset($r_item['${compo.name}']['nofollow']) ? $r_item['${compo.name}']['nofollow'] : '';\n`

                if (repeater_variable?.[repeater]) {
                    r_html = repeater_variable?.[repeater] + r_html;
                }

                repeater_variable = Object.assign({}, repeater_variable, { [repeater]: r_html })
            }
            else {
                php_variable_validation += `$${compo.name}_is_external = isset( $this->settings['${compo.name}']) ?  $this->settings['${compo.name}']['is_external'] : '';\n`

                php_variable_validation += `$${compo.name}_url = isset( $this->settings['${compo.name}']) ?  $this->settings['${compo.name}']['url'] : '';\n`

                php_variable_validation += `$${compo.name}_nofollow = isset( $this->settings['${compo.name}']) ?  $this->settings['${compo.name}']['nofollow'] : '';\n`
            }

            widgetHtml = widgetHtml.replaceAll(`{{${compo.name}-is_external}}`, `'.$${compo.name}_is_external.'`)

            widgetHtml = widgetHtml.replaceAll(`{{${compo.name}-url}}`, `'.$${compo.name}_url.'`)

            widgetHtml = widgetHtml.replaceAll(`{{${compo.name}-nofollow}}`, `'.$${compo.name}_nofollow.'`)


        } else if (compo.type == 'media') {
            if (widgetHtml.search(compo.name) >= 1) {
                if (repeater) {
                    let r_html = `$${compo.name} = isset($r_item['${compo.name}']) ? wp_get_attachment_image(
                    $r_item['${compo.name}']['id'],
                    $r_item['${compo.name}']['size'],
                    false,
                    [] // Image attributes
                  ) : '';\n`

                    if (repeater_variable?.[repeater]) {
                        r_html = repeater_variable?.[repeater] + r_html;
                    }
                    repeater_variable = Object.assign({}, repeater_variable, { [repeater]: r_html })

                } else {
                    php_variable_validation += `$${compo.name} = isset($this->settings['${compo.name}']) ?  wp_get_attachment_image(
                        $this->settings['${compo.name}']['id'],
                        $this->settings['${compo.name}']['size'],
                        false,
                        [] // Image attributes
                      ) : '';\n`
                }
                widgetHtml = widgetHtml.replaceAll(`{{${compo.name}}}`, `'.$${compo.name}.'`)
            }
        } else if (compo.type == 'repeater') {

            Loopvar.push({ 'type': compo.type, 'name': compo.name, 'repeater': repeater });

            let html = GetLoopHtml(compo.name);

            if (html) {
                html.map((html_data, index) => {
                    let repeater_html = html_data;

                    compo.fields.map((field) => {
                        settings += ControllerHtmlLoop(field, compo.name);

                        if (repeater_html) {
                            if (html_data.search(`data-${field.name}="{${field.name}}"`) > -1) {
                                const StringToHTML = function (str) {
                                    let parser = new DOMParser(),
                                        doc = parser.parseFromString(str, 'text/html');
                                    return doc.body;
                                };

                                let loop_html = StringToHTML(repeater_html);
                                if (loop_html.querySelector(`[data-${field.name}]`) && loop_html.querySelector(`[data-${field.name}]`).outerHTML) {
                                    let r_html = loop_html.querySelector(`[data-${field.name}]`).outerHTML;
                                    widgetHtml = widgetHtml.replaceAll(r_html, `'.$${field.name + index}.'`)
                                }
                            } else {
                                if (field.type == 'media' || field.type == 'iconscontrol') {
                                    widgetHtml = widgetHtml.replaceAll(`{{${field.name}}}`, `' . $${field.name} . '`)
                                } else if (field.type == 'url') {
                                    widgetHtml = widgetHtml.replaceAll(`{{${field.name}-url}}`, `' . $${field.name}_url . '`)
                                    widgetHtml = widgetHtml.replaceAll(`{{${field.name}-is_external}}`, `' . $${field.name}_is_external . '`)
                                    widgetHtml = widgetHtml.replaceAll(`{{${field.name}-nofollow}}`, `' . $${field.name}_nofollow . '`)
                                } else if (field.type == 'svg') {
                                    widgetHtml = widgetHtml.replaceAll(`{{${field.name}}}`, `' . $${field.name} . '`)
                                } else {
                                    widgetHtml = widgetHtml.replaceAll(`{{${field.name}}}`, `' . $r_item['${field.name}'] . '`)
                                }
                            }
                            widgetHtml = widgetHtml.replaceAll(`{loop-class-repeater}`, `bricks-repeater-item-' .esc_attr($r_item['id']) . '`)
                            widgetHtml = widgetHtml.replaceAll(`{{${compo.name}_index}}`, `'.$key.'`);
                            widgetHtml = widgetHtml.replaceAll(`{{${compo.name}_UID}}`, `'.esc_attr($r_item['id']).'`);
                        }
                    })
                })
            }
        } else if (compo.type == 'gallery') {
            Loopvar.push({ 'type': compo.type, 'name': compo.name, 'repeater': repeater });

            let html = GetLoopHtml(compo.name);

            if (html) {
                html.map((html_data, index) => {
                    let gallery_html = html_data;
                    if (gallery_html) {
                        `$compo.name += wp_get_attachment_image( $image['id'], $this->settings['gallery_5moxki23']['size'], false, ['class' => 'css-filter'])`;
                    }
                });
                widgetHtml = widgetHtml.replaceAll("{{" + compo.name + "}}", `' . $${compo.name} . '`)

            }
        } else if (compo.type == 'select2') {

            Loopvar.push({ 'type': compo.type, 'name': compo.name, 'repeater': repeater, 'multiple': compo.multiple });
            let html = GetLoopHtml(compo.name);
            if (html) {
                html.map((html_data, index) => {
                    let select2_html = html_data;
                    if (select2_html) {
                        if (compo.multiple) {
                            widgetHtml = widgetHtml.replaceAll("{{" + compo.name + "}}", "' .$s_item. '")
                        } else {
                            widgetHtml = widgetHtml.replaceAll("{{" + compo.name + "}}", `' .$settings['${compo.name}']. '`)
                        }
                    }
                })
            }

        } else if (compo.type == 'icon') {

            if (widgetHtml.search(compo.name) >= 1) {
                if (repeater) {
                    let r_html = `$${compo.name} = "";
                        if(isset($r_item['${compo.name}']) && isset($r_item['${compo.name}']['value'])){
                            ob_start();
                                \\Bricks\\Icons_Manager::render_icon($r_item['${compo.name}'],['aria-hidden'=>'true']);
                                $Icon = ob_get_contents();
                            ob_end_clean();
                            $${compo.name} .= '<span class="tp-title-icon">'.$Icon.'</span>';
                        };\n`

                    if (repeater_variable?.[repeater]) {
                        r_html = repeater_variable?.[repeater] + r_html;
                    }

                    repeater_variable = Object.assign({}, repeater_variable, { [repeater]: r_html })
                } else {
                    php_variable_validation += `$${compo.name} = isset( $this->settings['${compo.name}'] ) ?  '<i class="'.$this->settings['${compo.name}']['icon'].'"></i>' : '';\n`
                }

                widgetHtml = widgetHtml.replaceAll(`{{${compo.name}}}`, `'.$${compo.name}.'`)
            }
        } else if (compo.type == 'svg') {
            if (repeater) {
                let r_html = `$${compo.name} = isset( $r_item['${compo.name}']['url'] ) ? file_get_contents( esc_url( $r_item['${compo.name}']['url'] ) ) : '';\n`
                if (repeater_variable?.[repeater]) {
                    r_html = repeater_variable?.[repeater] + r_html;
                }
                repeater_variable = Object.assign({}, repeater_variable, { [repeater]: r_html })

            } else {
                php_variable_validation += `$${compo.name} =
                isset( $this->settings['${compo.name}']['url'] ) ? file_get_contents( esc_url( $this->settings['${compo.name}']['url'] ) ) : '';\n`
                widgetHtml = widgetHtml.replaceAll(`{{${compo.name}}}`, `'.$${compo.name}.'`)
            }

        } else if (compo.type == 'headingtags') {
            settings += `\n$${compo.name} = !empty($this->settings['${compo.name}']) ? $this->settings['${compo.name}'] : "";`
            widgetHtml = widgetHtml.replaceAll(compo.name, `'.$${compo.name}.'`)
        } else if (compo.type == 'query') {
            if (repeater) {
                let r_html = `$query_args = $this->settings['${compo.name}'];
                    $posts_query = new WP_Query( $query_args );

                    if ( $posts_query->have_posts() ) :
                        while ( $posts_query->have_posts() ) : $posts_query->the_post();
                        the_title( '<h5>', '</h5>' );
                        the_post_thumbnail( 'thumbnail' );
                        endwhile;
                        wp_reset_postdata();
                    else : 
                        esc_html_e( 'No posts matched your criteria.', 'bricks' );
                        endif;;\n`

                if (repeater_variable?.[repeater]) {
                    r_html = repeater_variable?.[repeater] + r_html;
                }
                repeater_variable = Object.assign({}, repeater_variable, { [repeater]: r_html })

            } else {
                php_variable_validation += `$query_args = $this->settings['${compo.name}'];
                    $posts_query = new WP_Query( $query_args );

                    if ( $posts_query->have_posts() ) :
                        while ( $posts_query->have_posts() ) : $posts_query->the_post();
                        the_title( '<h5>', '</h5>' );
                        the_post_thumbnail( 'thumbnail' );
                        endwhile;
                        wp_reset_postdata();
                    else : 
                        esc_html_e( 'No posts matched your criteria.', 'bricks' );
                        endif;\n`
            }
            widgetHtml = widgetHtml.replaceAll(`{{${compo.name}}}`, `'.$${compo.name}.'`)
        } else {
            if (repeater) {
                widgetHtml = widgetHtml.replaceAll(`{{${compo.name}}}`, `' . $r_item['${compo.name}'] . '`)
            } else {
                php_variable_validation += `$${compo.name} =
                isset( $this->settings['${compo.name}'] ) ? $this->settings['${compo.name}'] : '';\n`
                widgetHtml = widgetHtml.replaceAll(`{{${compo.name}}}`, `'.$${compo.name}.'`)
            }
        }

        return settings;

    };

    if (all_files.Editor_data?.links[0]?.js?.length > 0) {
        all_files.Editor_data.links[0].js.map(function (links) {
            if (links) {
                js_link += `wp_enqueue_script( 'my_child_script_${KeyUniqueID()}', '${links}', [], '${wdkitData.WDKIT_VERSION}.${UniqueNumber()}', true );\n`
            }
        });
    }

    if (all_files.Editor_data?.links[0]?.css?.length > 0) {
        all_files.Editor_data.links[0].css.map(function (links) {
            if (links) {
                css_link += `wp_enqueue_style( 'wd_css_ex_1_${KeyUniqueID()}', '${links}', false, '${wdkitData.WDKIT_VERSION}.${UniqueNumber()}', 'all' );\n`
            }
        });
    }

    all_files.CardItems?.cardData?.[0].layout.map((section) => {

        section.inner_sec.map((compo) => {
            if (php_editor_code) {
                php_editor_code = php_editor_code.replaceAll(`{{${compo.name}}}`, compo.name)
            }
            php_variable += ControllerHtmlLoop(compo);
        })
    })

    Loopvar.length > 0 && Loopvar.map((widgetHtml) => {
        CheckLoop(widgetHtml.name)
    })

    all_files.CardItems?.cardData?.[0].layout.map((section_data) => {

        section_data.inner_sec.map((compo) => {

            layout_data += Bricks_data(compo, 'content');

        })
    })

    all_files.CardItems?.cardData?.[0].style.map((section_data) => {

        section_data.inner_sec.map((compo) => {

            layout_data += Bricks_data(compo, 'style');

        })
    })

    var bricks_php = `
    <?php 

    /** 
     * Exit if accessed directly.
     */
    if ( ! defined( 'ABSPATH' ) ) {
        exit; 
    } 
    
    if ( ! class_exists( '${NameValidation("file").replaceAll("-", "_")}' ) ) {

    class ${NameValidation("file").replaceAll("-", "_")} extends \\Bricks\\Element {
      // Element properties
      public $category     = '${all_files?.WcardData?.widgetdata?.category}'; // Use predefined element category 'general'
      public $name         = 'wb-${all_files?.WcardData?.widgetdata?.widget_id}'; // Make sure to prefix your elements
      public $icon         = '${all_files?.WcardData?.widgetdata?.w_icon}'; // Themify icon font class
      public $css_selector = '.wkit-wb-Widget_${all_files?.WcardData?.widgetdata?.widget_id}'; // Default CSS selector
      public $scripts      = array('${NameValidation("file")}.js'); // Script(s) run when element is rendered on frontend or updated in builder
    
      // Return localised bricks label
      public function get_label() {
        return esc_html__( '${NameValidation()}', 'Bricks' );
      }
    
      // Set builder control groups
      public function set_control_groups() {
        $this->control_groups['datacontrols'] = [ // Unique group identifier (lowercase, no spaces)
          'title' => esc_html__( 'Data Controls', 'bricks' ), // Localized control group title
          'tab' => 'content', // Set to either "content" or "style"
        ];
    
      }
     
      // Set builder controls
      public function set_controls() {
        ${layout_data}
      }
      public function enqueue_scripts() {

        ${js_link}
        wp_enqueue_script( 'wkit_child_script_${script_id}', wp_upload_dir()['baseurl'].'/wdesignkit/bricks/${NameValidation("folder")}/${NameValidation("file")}.js', [], '${wdkitData.WDKIT_VERSION}.${UniqueNumber()}', true  );
        
        ${css_link}
        wp_enqueue_style( 'wkit_child_script_${script_id}', wp_upload_dir()['baseurl'].'/wdesignkit/bricks/${NameValidation("folder")}/${NameValidation("file")}.css', [], '${wdkitData.WDKIT_VERSION}.${UniqueNumber()}', false  );
      }

      // Render element HTML
      public function render() {
        // Set element attributes
        $root_classes[] = 'wkit-wb-Widget_${all_files?.WcardData?.widgetdata?.widget_id}';
        
        if ( ! empty( $this->settings['type'] ) ) {
          $root_classes[] = "color-{$this->settings['type']}";
        }
    
        // Add 'class' attribute to element root tag
        $this->set_attribute( '_root', 'class', $root_classes );
        
        // Render element HTML
        ${php_editor_code ?
            php_editor_code
            :
            `        
        ${php_variable_validation}
        ${php_variable}
       
        // '_root' attribute is required since Bricks 1.4 (contains element ID, class, etc.)
        $output = '';
        $output .= '<div ' . $this->render_attributes('_root') . ' class="wkit-wb-Widget_${all_files.WcardData?.widgetdata?.widget_id}" data-wdkitunique="${all_files.WcardData?.widgetdata?.widget_id}">';
        $output .= '${widgetHtml}';
        $output .= '</div>';
        echo $output;    `
        }
      }
    }
    }
    `;

    var bricks_js = js != `""` ? `class MyClass_${unique_class} {
        constructor() {
            setTimeout(() => {
                let main_html = document.querySelectorAll(".wkit-wb-Widget_${all_files.WcardData.widgetdata.widget_id}")    
                    main_html.forEach(element => {
                        this.main_function_${unique_class}(element)
                    });
            }, 800);
        }

    main_function_${unique_class}($scope) {
        ${JSON.parse(js)} 
    }
}

    new MyClass_${unique_class}();` : '';

    var bricks_css = `${CssValidation()}`,
        widget_info = Object.assign({}, ImageLink().widgetdata, { 'wkit-version': wdkitData.WDKIT_VERSION });
    let widget_data = { 'widgetdata': widget_info };

    var json_section = JSON.stringify(all_files.CardItems.cardData),
        json_widget = JSON.stringify(widget_data),
        editor_link = JSON.stringify(all_files.Editor_data),

        json_data = `{
        "section_data":${json_section},
        "widget_data":${json_widget},
        "Editor_Link":${editor_link},
        "Editor_data":{
            "html":${html},
            "css":${css},
            "js":${js},
            "php":${JSON.stringify(php_editor_code)}
            }
        }`;

    if (old_folder == undefined) {
        var old_name = "";
    } else {
        var old_name = old_folder;
    }

    var values = {
        "old_folder": old_name,
        'file_name': NameValidation("file"),
        'folder_name': NameValidation("folder"),
        'description': all_files.WcardData.widgetdata.description,
        'bricks_php_file': bricks_php,
        'bricks_js': bricks_js,
        'bricks_css': bricks_css,
        'json_file': json_data,
        "plugin": "bricks",
        "d_image": d_image ? d_image : '',
        "call": call,
    };

    var formData = new FormData();
    formData.append('action', 'get_wdesignkit');
    formData.append('kit_nonce', wdkitData.kit_nonce);
    formData.append('image', image_file);
    formData.append('type', 'wkit_create_widget');
    formData.append('value', JSON.stringify(values));

    await axios.post(ajaxurl, formData, {
        headers: { 'content-type': 'application/json' }
    }).then((response) => {
        if (200 == response.status) {
            if (document.querySelector('.wb-function-call')) {
                document.querySelector('.wb-function-call').click();
            }
            responses.api = response.data;
        } else {
        }
    }).catch(error => console.error(error));

    var NewImage = all_files.WcardData.widgetdata.w_image;
    var NewImageExt = all_files.WcardData.widgetdata.img_ext;

    const Get_image_info = async () => {

        let Json_URL = `${wdkitData.WDKIT_SERVER_PATH}/bricks/${NameValidation("folder")}/${NameValidation("file")}.json`;

        let New_json = await axios.get(Json_URL).then(async (response) => { return await response?.data })

        if (New_json?.widget_data?.widgetdata?.w_image) {
            NewImage = New_json?.widget_data?.widgetdata?.w_image;
            NewImageExt = New_json?.widget_data?.widgetdata?.img_ext;
        }

    }

    let token = get_user_login();
    if (token && (call == 'sync')) {
        await Get_image_info();
        let data = {
            'token': token.token,
            'type': 'add',
            'title': NameValidation(),
            'content': all_files.WcardData.widgetdata.description,
            'builder': all_files.WcardData.widgetdata.type,
            'w_data': json_data,
            'w_uniq': all_files.WcardData.widgetdata.widget_id,
            "w_image": NewImage,
            "w_imgext": NewImageExt,
            "w_version": all_files.WcardData.widgetdata.widget_version,
            "w_updates": all_files.WcardData.widgetdata.version_detail,
            "r_id": all_files?.WcardData?.widgetdata?.r_id ? all_files?.WcardData?.widgetdata?.r_id : 0,
        }

        let form_arr = { 'type': 'wkit_add_widget', 'widget_info': JSON.stringify(data) }
        await wdKit_Form_data(form_arr).then((result) => {
            if (result?.success) {
                // Show_toast(result?.data?.message, 'success')
            } else {
                let error_msg = result?.message ? result?.message : 'Operation Fail';
                // Show_toast(error_msg, 'danger')
            }
            responses.ajax = { 'data': result };
        })
    }

    return responses;

}

export default Bricks_file_create;
